import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';

import TitleWithShape from 'components/TitleWithShape';
import IconButton from 'components/IconButton';
import InputField from 'components/InputField';
import HelpText from 'components/HelpText';
import BackButton from 'components/BackButton';

const Wrapper = styled.div`
  color: #35447d;
  display: flex;
  justify-content: space-between;
  padding-left: 5.4rem;
  padding-right: 16rem;
  margin-top: 7.1rem;
  .form-wrapper {
    background: #e1e1e1;
    width: 66rem;
    height: 114.2rem;
    position: relative;
    .bar-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 3rem;
      padding-right: 3.7rem;
      padding-left: 3.7rem;
    }
    .form-title {
      margin-top: 6.2rem;
      margin-left: 10.3rem;
    }
    .button-wrapper {
      margin-top: 4rem;
      display: flex;
      margin-left: 10.3rem;
    }
    .fields {
      position: absolute;
      padding: 5rem 8.5rem;
      background: #f8f7f3;
      width: 64.4rem;
      top: 34.6rem;
      left: 10.6rem;
      .options-wrapper {
        margin-top: 2rem;
        display: flex;
        flex-wrap: wrap;
      }
      .next-button {
        margin-top: 8rem;
        margin-bottom: 4rem;
        display: flex;
        justify-content: flex-end;
      }
      h1 {
        font-weight: normal;
        margin-top: 4rem;
      }
    }
    .error {
      font-size: 1.2rem
    }
  }
  .info-wrapper {
    margin-top: 35.6rem;
    width: 36rem;
  }
  @media only screen and (max-width: 1400px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    .info-wrapper {
      margin-top: 1rem;
      margin-bottom: 2rem;
    }
  }

  @media only screen and (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
    .form-wrapper {
      height: auto;
      .fields {
        position: relative;
        width: 80%;
        left: 0;
        top: 4rem;
        margin: auto;
      }
    }
  }
`;

class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = props.formData;
    // Default state
    this.state.courtCommencingOption = this.state.courtCommencingOption || -1;
    this.state.courtLikelyhoodOption = this.state.courtLikelyhoodOption || -1;
    this.state.courtProceedingsOption = this.state.courtProceedingsOption || -1;
    this.state.partyOption = this.state.partyOption || -1;
    this.state.redirect = false;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChange = (e, key) => {
    this.setState({ [key]: e.target.value });
  }

  nextFormPage() {
    if (!this.validate()) { return; }
    this.setState({ completed: true }, () => {
      this.props.collectData('step2', this.state);
      this.setState({ redirect: '/get-started/step-three' });
    });
  }

  updateOption(key, val) {
    this.setState({ [key]: val });
  }

  validate() {
    this.setState({
      partyError: false,
      likelyhoodError: false,
      otherFieldError: false,
    });

    switch (this.state.courtProceedingsOption) {
      case 'Yes':
        switch (this.state.partyOption) {
          case -1:
            this.setState({ partyError: true });
            break;
          case 'Other':
            if (this.state.otherPartyField === undefined || this.state.otherPartyField.length === 0) {
              this.setState({ otherFieldError: true });
              break;
            } else {
              return true;
            }
          default:
            return true;
        }
        break;
      case 'No':
        return true;
      case 'Maybe':
        if (this.state.courtLikelyhoodOption === -1) {
          this.setState({ likelyhoodError: true });
          break;
        } else {
          return true;
        }
      default:
        break;
    }
    return false;
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    const {
      courtCommencingOption,
      courtLikelyhoodOption,
      courtProceedingsOption,
      partyOption,
    } = this.state;

    return (
      <Wrapper>
        <div className="form-wrapper">
          <div className="bar-wrapper">
            <BackButton />
          </div>
          <div className="form-title">
            <TitleWithShape
              title="Are you currently involved in court proceedings?"
            />
          </div>
          <div className="button-wrapper">
            <IconButton
              name="Yes"
              icon="downArrow"
              width={15.3}
              rightMargin={1.5}
              onClick={() => this.updateOption('courtProceedingsOption', 'Yes')}
              selected={courtProceedingsOption === 'Yes'}
            />
            <IconButton
              name="No"
              icon="no"
              width={15.3}
              rightMargin={1.5}
              onClick={() => this.updateOption('courtProceedingsOption', 'No')}
              selected={courtProceedingsOption === 'No'}
            />
            <IconButton
              name="Unsure / Maybe"
              icon="unsure"
              width={20}
              onClick={() => this.updateOption('courtProceedingsOption', 'Maybe')}
              selected={courtProceedingsOption === 'Maybe'}
            />
          </div>

          {courtProceedingsOption !== -1 && (
            <div className="fields">
              {courtProceedingsOption === 'Yes' && (
                <div>
                  <InputField placeholder="Court Name" value={this.state.courtName} name="courtName" onChange={this.onChange} unsureBtn />
                  <InputField placeholder="Proceedings number" value={this.state.proceedingsNumber} name="proceedingsNumber" onChange={this.onChange} unsureBtn />
                  <InputField placeholder="Who represents the other parties" value={this.state.whoRepresentsOtherParty} name="whoRepresentsOtherParty" onChange={this.onChange} unsureBtn />
                  <h1>Which party are you?*</h1>
                  <div className="options-wrapper">
                    <IconButton
                      name="Plaintiff"
                      icon="circle"
                      rightMargin={1.5}
                      bottomMargin={2}
                      onClick={() => this.updateOption('partyOption', 'Plaintiff')}
                      selected={partyOption === 'Plaintiff'}
                    />
                    <IconButton
                      name="Defendant"
                      icon="circle"
                      rightMargin={1.5}
                      bottomMargin={2}
                      onClick={() => this.updateOption('partyOption', 'Defendant')}
                      selected={partyOption === 'Defendant'}
                    />
                    <IconButton
                      name="Other"
                      icon="circle"
                      rightMargin={1.5}
                      bottomMargin={2}
                      onClick={() => this.updateOption('partyOption', 'Other')}
                      selected={partyOption === 'Other'}
                    />
                    <IconButton
                      name="Unsure"
                      icon="unsure"
                      bottomMargin={2}
                      onClick={() => this.updateOption('partyOption', 'Unsure')}
                      selected={partyOption === 'Unsure'}
                    />
                  </div>
                  {this.state.partyError && <span className="error">This field is required</span>}
                  {partyOption === 'Other' && <InputField placeholder="Other" value={this.state.otherPartyField} name="otherPartyField" onChange={this.onChange} isRequired />}
                  {this.state.otherFieldError && <span className="error">This field is required</span>}
                </div>
              )}

              {courtProceedingsOption === 'Maybe' && (
                <div>
                  <h1 style={{ marginTop: '0' }}>How likely is it?*</h1>
                  <div className="options-wrapper">
                    <IconButton
                      name="Likely"
                      icon="circle"
                      bottomMargin={2}
                      rightMargin={1.5}
                      onClick={() => this.updateOption('courtLikelyhoodOption', 'Likely')}
                      selected={courtLikelyhoodOption === 'Likely'}
                    />
                    <IconButton
                      name="Unlikely"
                      icon="circle"
                      bottomMargin={2}
                      rightMargin={1.5}
                      onClick={() => this.updateOption('courtLikelyhoodOption', 'Unlikely')}
                      selected={courtLikelyhoodOption === 'Unlikely'}
                    />
                    <IconButton
                      name="Unsure"
                      icon="circle"
                      bottomMargin={2}
                      onClick={() => this.updateOption('courtLikelyhoodOption', 'Unsure')}
                      selected={courtLikelyhoodOption === 'Unsure'}
                    />
                  </div>
                  {this.state.likelyhoodError && <span className="error">This field is required</span>}

                  {['Likely', 'Unlikely'].indexOf(courtLikelyhoodOption) !== -1 && (
                    <div>
                      <h1>When might court proceedings commence?</h1>
                      <div className="options-wrapper" style={{ flexWrap: 'wrap' }}>
                        <IconButton
                          name="Less than 1 month"
                          icon="circle"
                          rightMargin={1.5}
                          bottomMargin={2}
                          onClick={() => this.updateOption('courtCommencingOption', 'Less than 1 month')}
                          selected={courtCommencingOption === 'Less than 1 month'}
                        />
                        <IconButton
                          name="More than 1 month"
                          icon="circle"
                          rightMargin={1.5}
                          bottomMargin={2}
                          onClick={() => this.updateOption('courtCommencingOption', 'More than 1 month')}
                          selected={courtCommencingOption === 'More than 1 month'}
                        />
                        <IconButton
                          name="Unsure"
                          icon="unsure"
                          rightMargin={1.5}
                          onClick={() => this.updateOption('courtCommencingOption', 'Unsure')}
                          selected={courtCommencingOption === 'Unsure'}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

              <div className="next-button">
                <IconButton
                  name="Save and continue"
                  icon="downArrow"
                  onClick={() => this.nextFormPage()}
                  selected
                  noBorder
                />
              </div>
            </div>
          )}
        </div>

        {courtProceedingsOption === 'Yes' && (
          <div className="info-wrapper">
            <HelpText>Your court name and proceedings number should be listed on your summons document.</HelpText>
          </div>
        )}

        {courtProceedingsOption === 'Maybe' && (
          <div className="info-wrapper">
            <HelpText>If you're unsure let us know if it's at all likely court proceedings would begin with you as a party and when this might start</HelpText>
          </div>
        )}
      </Wrapper>
    );
  }
}

Step2.propTypes = {
  collectData: PropTypes.func.isRequired,
  formData: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Step2;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step2.js